'use client'
import { useState, useEffect } from 'react';
import Image from 'next/image';
import LocalizedName from '@/components/LocalizedName';
import ImageModal from '@/components/ImageModal';
import Link from 'next/link';

export default function Gallery() {
    const [selectedImage, setSelectedImage] = useState(null);
    const [selectedUploader, setSelectedUploader] = useState(null);
    const [galleryImages, setGalleryImages] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetchPublicGallery();
    }, []);

    const fetchPublicGallery = async () => {
        try {
            const response = await fetch('/api/gallery/public');
            const data = await response.json();

            if (data.success) {
                setGalleryImages(data.gallery);
            }
        } catch (error) {
            console.error('Error fetching gallery:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleImageClick = (image) => {
        setSelectedImage(image.path);
        setSelectedUploader(image.uploadedBy);
    };

    if (loading) {
        return (
            <div className="gallery">
                <div className="container">
                    <div style={{ padding: '40px', textAlign: 'center' }}>
                        <p>Loading gallery...</p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="gallery">
                <div className="container">

                    <div className="gallery_cont">
                        {galleryImages.map((image) => (
                            <div
                                key={image._id}
                                className="gal_card"
                                onClick={() => handleImageClick(image)}
                                role="button"
                                tabIndex={0}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        handleImageClick(image);
                                    }
                                }}
                            >
                                <div className="gallery_image_wrapper">
                                    <Image
                                        src={image.path}
                                        alt={`Uploaded by ${image.uploadedBy.name} ${image.uploadedBy.surname}`}
                                        width={400}
                                        height={300}
                                        quality={60}
                                        loading="lazy"
                                        placeholder="blur"
                                        blurDataURL="data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAAAQABAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAAIAAoDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwCdABmX/9k="
                                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                        style={{ objectFit: 'cover', width: '100%', height: '100%' }}
                                    />
                                </div>
                                <div className="gallery_uploader_tag">
                                    <div className="uploader_info">
                                        {/* {image.uploadedBy.photo && (
                                            <Image
                                                src={image.uploadedBy.photo}
                                                alt={image.uploadedBy.name}
                                                width={24}
                                                height={24}
                                                className="uploader_avatar"
                                            />
                                        )} */}
                                        <Link href={`/profile/${image.uploadedBy.id}`} className="uploader_name">
                                            <LocalizedName user={image.uploadedBy} initial={`${image.uploadedBy.name} ${image.uploadedBy.surname}`} />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    {galleryImages.length === 0 && (
                        <div style={{ textAlign: 'center', padding: '40px', color: '#666' }}>
                            <p>No public images yet. Be the first to share!</p>
                        </div>
                    )}
                </div>
            </div>

            <ImageModal
                isOpen={!!selectedImage}
                imageSrc={selectedImage}
                onClose={() => {
                    setSelectedImage(null);
                    setSelectedUploader(null);
                }}
                alt="Gallery image"
            />
        </>
    );
}
